import { KeycloakTokenContent } from '@luminalearning/types';
import jwtDecode from 'jwt-decode';
import env from 'src/env';
import * as types from 'src/types';

const adjustTokenProfile = (profile: types.Profile) => {
    let adjustedProfile = { ...profile };
    if (adjustedProfile) {
        // First process moving namespaced claims back to the root of our profile

        const claimsKey = 'https://sso.luminalearning.com/claims';

        if (claimsKey in adjustedProfile) {
            // We have generic claims now namespaced, move all of these back to the root of the profile after checking
            // not already set
            // eslint-disable-next-line no-param-reassign
            adjustedProfile = {
                // Merge claims and the profile, with profile properties taking priority
                ...adjustedProfile[claimsKey],
                ...adjustedProfile,
            };

            // Delete the namespaced claim from the profile as we no longer need it
            // eslint-disable-next-line no-param-reassign
            delete adjustedProfile[claimsKey];
        }

        // Now we have sorted the namespacing we can process other profile changes...
        if (
            !('identities' in adjustedProfile)
            && 'identities_min' in adjustedProfile
        ) {
            // We have identities_min but not identities, this is because we needed to shrink it in Auth0 rule
            // We want to move this back to identities for now, if we need more detail later we can fetch it from the
            // API instead
            // eslint-disable-next-line no-param-reassign
            adjustedProfile.identities = adjustedProfile.identities_min;
            // eslint-disable-next-line no-param-reassign
            delete adjustedProfile.identities_min;
        }
    }
    return adjustedProfile;
};

const decodeAuth0Token = (token: string) => {
    const profile = jwtDecode(token);
    return adjustTokenProfile(profile as types.Profile);
};

const decodeKeycloakToken = (token: string) => {
    try {
        const decoded = jwtDecode(token) as KeycloakTokenContent;

        const isTokenExpired = decoded.exp < Math.round(new Date().getTime() / 1000);
        const isIssValid = decoded.iss === `${env.keycloak.serverUrl}/realms/${env.keycloak.realm}`;

        if (!isTokenExpired && isIssValid) {
            return decoded;
        }
    } catch (error) {
        const err = error as Error;
        console.error(err.message);
    }

    return null;
};

export {
    decodeAuth0Token,
    decodeKeycloakToken,
};
